import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const NutritionVitaminADiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const bcmo1 = getGenePalette(geneColors.BCMO1);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18284_196595)">
        <rect width={1024} height={1344} transform="translate(0 176)" fill="white" />
        <g id="vitamin_a-diagram">
          <rect width={1024} height={1344} transform="translate(0 176)" fill="white" />
          <g id="lines">
            <text
              id="Line Label"
              transform="translate(542 519) rotate(90)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={45.415} y={16.767}>
                CONVERTED TO
              </tspan>
            </text>
            <path
              id="Vector"
              d="M511.658 519.7L511.658 519L510.258 519L510.258 519.7L510.958 519.7L511.658 519.7ZM510.958 712L515 705L506.917 705L510.958 712ZM510.958 519.7L510.258 519.7L510.258 705.7L510.958 705.7L511.658 705.7L511.658 519.7L510.958 519.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_2">
            <text
              id="Line Label_2"
              transform="translate(542 787) rotate(90)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={45.415} y={16.767}>
                CONVERTED TO
              </tspan>
            </text>
            <path
              id="Vector_2"
              d="M511.658 787.7L511.658 787L510.258 787L510.258 787.7L510.958 787.7L511.658 787.7ZM510.958 980L515 973L506.917 973L510.958 980ZM510.958 787.7L510.258 787.7L510.258 973.7L510.958 973.7L511.658 973.7L511.658 787.7L510.958 787.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="report-label">
            <g id="Report titles">
              <rect width={157} height={64} transform="translate(433 987)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={28}
                letterSpacing="0em"
              >
                <tspan x={466.738} y={1014.56}>
                  Retinol
                </tspan>
              </text>
              <text
                id="Sub label"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={433.119} y={1043.12}>
                  (Intermediate form)
                </tspan>
              </text>
            </g>
            <g id="lines_3">
              <path
                id="Vector_3"
                d="M512.158 1055.7L512.158 1055L510.758 1055L510.758 1055.7L511.458 1055.7L512.158 1055.7ZM511.458 1259L515.5 1252L507.417 1252L511.458 1259ZM511.458 1055.7L510.758 1055.7L510.758 1252.7L511.458 1252.7L512.158 1252.7L512.158 1055.7L511.458 1055.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="detail box">
            <path
              d="M278 236.7H746C752.241 236.7 757.3 241.759 757.3 248V492C757.3 498.241 752.241 503.3 746 503.3H278C271.759 503.3 266.7 498.241 266.7 492V248C266.7 241.759 271.759 236.7 278 236.7Z"
              stroke="#1A1A1A"
              strokeWidth={1.4}
            />
            <g id="Rich Text Block">
              <g id="Frame 483">
                <text
                  id="H2 Header"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={24}
                  letterSpacing="0em"
                >
                  <tspan x={429.875} y={290.196}>
                    Beta-carotene
                  </tspan>
                </text>
                <text
                  id="H2 Header_2"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Regular"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={474.047} y={319.44}>
                    (Precursor)
                  </tspan>
                </text>
              </g>
              <g id="Plant-based foods Vegetables: Carrots, sweet potatoes, pumpkin, butternut squash, spinach, kale... Fruits: Cantaloupe, mangoes, papaya, apricots, peaches... Other: Fortified foods...">
                <text
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={386.016} y={383.464}>
                    Carrots, sweet potatoes, pumpkin, butternut{" "}
                  </tspan>
                  <tspan x={294} y={411.464}>
                    squash, spinach, kale...{" "}
                  </tspan>
                  <tspan x={338.594} y={439.464}>
                    {" "}
                    Cantaloupe, mangoes, papaya, apricots, peaches...{" "}
                  </tspan>
                  <tspan x={345.219} y={467.464}>
                    Fortified foods...
                  </tspan>
                </text>
                <text
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={294} y={355.464}>
                    Plant-based foods{" "}
                  </tspan>
                  <tspan x={294} y={383.464}>
                    Vegetables:{" "}
                  </tspan>
                  <tspan x={294} y={439.464}>
                    Fruits:
                  </tspan>
                  <tspan x={294} y={467.464}>
                    Other:{" "}
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g id="outcome box">
            <path
              d="M688.011 1274V1274.7H690C690.756 1274.7 691.493 1274.77 692.206 1274.92L692.341 1274.23C693.915 1274.54 695.378 1275.16 696.666 1276.02L696.278 1276.6C697.511 1277.43 698.572 1278.49 699.397 1279.72L699.978 1279.33C700.84 1280.62 701.459 1282.08 701.771 1283.66L701.085 1283.79C701.226 1284.51 701.3 1285.24 701.3 1286V1288H702V1292H701.3V1296H702V1300H701.3V1304H702V1308H701.3V1312H702V1316H701.3V1320H702V1324H701.3V1328H702V1332H701.3V1336H702V1340H701.3V1344H702V1348H701.3V1352H702V1356H701.3V1360H702V1364H701.3V1368H702V1372H701.3V1376H702V1380H701.3V1384H702V1388H701.3V1392H702V1396H701.3V1400H702V1404H701.3V1408H702V1412H701.3V1416H702V1420H701.3V1424H702V1428H701.3V1432H702V1436H701.3V1440H702V1444H701.3V1446C701.3 1446.76 701.226 1447.49 701.085 1448.21L701.771 1448.34C701.459 1449.92 700.84 1451.38 699.978 1452.67L699.397 1452.28C698.572 1453.51 697.511 1454.57 696.278 1455.4L696.666 1455.98C695.378 1456.84 693.915 1457.46 692.341 1457.77L692.206 1457.08C691.493 1457.23 690.756 1457.3 690 1457.3H688.012V1458H684.033V1457.3H680.056V1458H676.078V1457.3H672.101V1458H668.122V1457.3H664.145V1458H660.167V1457.3H656.189V1458H652.211V1457.3H648.233V1458H644.256V1457.3H640.278V1458H636.3V1457.3H632.322V1458H628.345V1457.3H624.367V1458H620.389V1457.3H616.411V1458H612.434V1457.3H608.456V1458H604.478V1457.3H600.5V1458H596.522V1457.3H592.545V1458H588.566V1457.3H584.589V1458H580.611V1457.3H576.634V1458H572.655V1457.3H568.678V1458H564.7V1457.3H560.723V1458H556.744V1457.3H552.767V1458H548.789V1457.3H544.812V1458H540.833V1457.3H536.855V1458H532.878V1457.3H528.9V1458H524.922V1457.3H520.944V1458H516.967V1457.3H512.989V1458H509.011V1457.3H505.033V1458H501.056V1457.3H497.078V1458H493.1V1457.3H489.122V1458H485.145V1457.3H481.167V1458H477.188V1457.3H473.211V1458H469.233V1457.3H465.256V1458H461.277V1457.3H457.3V1458H453.322V1457.3H449.345V1458H445.366V1457.3H441.389V1458H437.411V1457.3H433.434V1458H429.455V1457.3H425.478V1458H421.5V1457.3H417.522V1458H413.545V1457.3H409.566V1458H405.589V1457.3H401.611V1458H397.634V1457.3H393.655V1458H389.678V1457.3H385.7V1458H381.723V1457.3H377.744V1458H373.767V1457.3H369.789V1458H365.812V1457.3H361.833V1458H357.855V1457.3H353.878V1458H349.9V1457.3H345.922V1458H341.944V1457.3H337.967V1458H333.989V1457.3H332C331.244 1457.3 330.507 1457.23 329.794 1457.08L329.658 1457.77C328.084 1457.46 326.621 1456.84 325.333 1455.98L325.722 1455.4C324.489 1454.57 323.428 1453.51 322.603 1452.28L322.021 1452.67C321.16 1451.38 320.54 1449.92 320.229 1448.34L320.915 1448.21C320.809 1447.67 320.741 1447.12 320.714 1446.56L320.7 1446V1444H320V1440H320.7V1436H320V1432H320.7V1428H320V1424H320.7V1420H320V1416H320.7V1412H320V1408H320.7V1404H320V1400H320.7V1396H320V1392H320.7V1388H320V1384H320.7V1380H320V1376H320.7V1372H320V1368H320.7V1364H320V1360H320.7V1356H320V1352H320.7V1348H320V1344H320.7V1340H320V1336H320.7V1332H320V1328H320.7V1324H320V1320H320.7V1316H320V1312H320.7V1308H320V1304H320.7V1300H320V1296H320.7V1292H320V1288H320.7V1286C320.7 1285.24 320.774 1284.51 320.915 1283.79L320.229 1283.66C320.54 1282.08 321.16 1280.62 322.021 1279.33L322.603 1279.72C323.428 1278.49 324.489 1277.43 325.722 1276.6L325.333 1276.02C326.621 1275.16 328.084 1274.54 329.658 1274.23L329.794 1274.92C330.507 1274.77 331.244 1274.7 332 1274.7H333.988V1274H337.967V1274.7H341.944V1274H345.922V1274.7H349.899V1274H353.878V1274.7H357.855V1274H361.833V1274.7H365.811V1274H369.789V1274.7H373.767V1274H377.744V1274.7H381.722V1274H385.7V1274.7H389.678V1274H393.655V1274.7H397.633V1274H401.611V1274.7H405.589V1274H409.566V1274.7H413.544V1274H417.522V1274.7H421.5V1274H425.478V1274.7H429.455V1274H433.434V1274.7H437.411V1274H441.389V1274.7H445.366V1274H449.345V1274.7H453.322V1274H457.3V1274.7H461.277V1274H465.256V1274.7H469.233V1274H473.211V1274.7H477.188V1274H481.167V1274.7H485.145V1274H489.122V1274.7H493.1V1274H497.078V1274.7H501.056V1274H505.033V1274.7H509.011V1274H512.989V1274.7H516.967V1274H520.944V1274.7H524.922V1274H528.9V1274.7H532.878V1274H536.855V1274.7H540.833V1274H544.812V1274.7H548.789V1274H552.767V1274.7H556.744V1274H560.723V1274.7H564.7V1274H568.678V1274.7H572.655V1274H576.634V1274.7H580.611V1274H584.589V1274.7H588.566V1274H592.545V1274.7H596.522V1274H600.5V1274.7H604.478V1274H608.455V1274.7H612.434V1274H616.411V1274.7H620.389V1274H624.366V1274.7H628.345V1274H632.322V1274.7H636.3V1274H640.277V1274.7H644.256V1274H648.233V1274.7H652.211V1274H656.188V1274.7H660.167V1274H664.145V1274.7H668.122V1274H672.1V1274.7H676.078V1274H680.056V1274.7H684.033V1274H688.011Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="Rich Text Block_2">
              <g id="Frame 483_2">
                <text
                  id="H2 Header_3"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={24}
                  letterSpacing="0em"
                >
                  <tspan x={472.633} y={1328.2}>
                    Retinol
                  </tspan>
                </text>
                <text
                  id="H2 Header_4"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Regular"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={448.633} y={1357.44}>
                    (Active vitamin A)
                  </tspan>
                </text>
              </g>
              <g id="Animal-based foods: Liver, fish, eggs, dairy... Other: Fortified foods...">
                <text
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={507.469} y={1393.46}>
                    Liver, fish, eggs, dairy...{" "}
                  </tspan>
                  <tspan x={399.219} y={1421.46}>
                    Fortified foods...
                  </tspan>
                </text>
                <text
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Bold"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={348} y={1393.46}>
                    Animal-based foods:{" "}
                  </tspan>
                  <tspan x={348} y={1421.46}>
                    Other:{" "}
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g id="gene-BCMO1" {...geneGroupProps("BCMO1", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M455 730C455 727.791 456.791 726 459 726H563C565.209 726 567 727.791 567 730V766C567 768.209 565.209 770 563 770H459C456.791 770 455 768.209 455 766V730Z"
                fill={bcmo1.lozengeFill}
              />
              <text
                id="gene-label_5"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={471.414} y={756.16}>
                  BCMO1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="bcmo1"
              groupId="gene-snps"
              genePalette={bcmo1}
              startX={463}
              startY={772}
              snpCount={getGeneSnpCount("BCMO1", expectedSnps, geneColors)}
            />
          </g>
        </g>
      </g>
    </>
  );
};

const SvgNutritionVitaminADiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={1344}
    viewBox="0 176 1024 1344"
    fill="none"
    {...props}
  >
    <NutritionVitaminADiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18284_196595">
        <rect width={1024} height={1520} fill="white" />
      </clipPath>
      <clipPath id="clip1_18284_196595">
        <rect width={1024} height={1344} fill="white" transform="translate(0 176)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgNutritionVitaminADiagram;
